import styled from "@emotion/styled";
import { CLEAN_FIRST_FOLD_MARGIN } from "constants/pricing-sizes";
export const StyledContactUsImage = styled.div`
  display: flex;
  align-items: center;

  .contact-us-image-wrapper {
    margin-left: ${CLEAN_FIRST_FOLD_MARGIN};
    margin-bottom: ${CLEAN_FIRST_FOLD_MARGIN};

    &.basic {
      img {
        filter: hue-rotate(-66deg);
      }
    }

    &.standard {
      img {
        filter: invert(1);
      }
    }

    &.pro {
      img {
        filter: brightness(0.7);
      }
    }

    &.enterprise {
      img {
        filter: brightness(0.4);
      }
    }
  }
`;
